module.exports = __webpack_public_path__ + "static_pc/img/add01.6a1a7af8.png";